import { UserDataType } from "../Data/UserData";
import { t } from "i18next";
export const teyvat: UserDataType = {
  stations: [
    {
      stationId: 1,
      stationName: t("wang-feng-jiao-zhan"),
      position: [678, -52],
      shape: "cicle",
      lineIds: [3],
      tagDirection: 2,
    },
    {
      stationId: 2,
      stationName: t("zhai-xing-ya-zhan"),
      position: [645, 71],
      shape: "cicle",
      lineIds: [3],
    },
    {
      stationId: 3,
      stationName: t("qian-feng-shen-dian-zhan"),
      position: [640, 191],
      shape: "cicle",
      lineIds: [3],
    },
    {
      stationId: 4,
      stationName: t("Common-teyvat-192be7b183f6eee79-1"),
      position: [463, 418],
      shape: "cicle",
      lineIds: [2, 3, 8],
    },
    {
      stationId: 5,
      stationName: t("Common-teyvat-192be7b183f6eee79-2"),
      position: [573, 641],
      shape: "cicle",
      lineIds: [3],
    },
    {
      stationId: 6,
      stationName: t("Common-teyvat-192be7b183f6eee79-3"),
      position: [740, 641],
      shape: "cicle",
      lineIds: [3],
    },
    {
      stationId: 7,
      stationName: t("Common-teyvat-192be7b183f6eee79-4"),
      position: [813, 533],
      shape: "cicle",
      lineIds: [3],
    },
    {
      stationId: 8,
      stationName: t("Common-teyvat-192be7b183f6eee79-5"),
      position: [388, 318],
      shape: "cicle",
      lineIds: [1, 2],
      tagDirection: 6
    },
    {
      stationId: 9,
      stationName: t("Common-teyvat-192be7b183f6eee79-6"),
      position: [458, 193],
      shape: "cicle",
      lineIds: [2],
    },
    {
      stationId: 10,
      stationName: t("Common-teyvat-192be7b183f6eee79-7"),
      position: [460, 86],
      shape: "cicle",
      lineIds: [2],
    },
    {
      stationId: 11,
      stationName: t("Common-teyvat-192be7b183f6eee79-8"),
      position: [458, -64],
      shape: "cicle",
      lineIds: [2],
    },
    {
      stationId: 12,
      stationName: t("Common-teyvat-192be7b183f6eee79-9"),
      position: [325, -102],
      shape: "cicle",
      lineIds: [2],
    },
    {
      stationId: 13,
      stationName: t("Common-teyvat-192be7b183f6eee79-10"),
      position: [245, 168],
      shape: "cicle",
      lineIds: [1],
    },
    {
      stationId: 14,
      stationName: t("Common-teyvat-192be7b183f6eee79-11"),
      position: [320, 226],
      shape: "cicle",
      lineIds: [1],
    },
    {
      stationId: 15,
      stationName: t("Common-teyvat-192be7b183f6eee79-12"),
      position: [270, 358],
      shape: "cicle",
      lineIds: [1],
    },
    {
      stationId: 16,
      stationName: t("Common-teyvat-192be7b183f6eee79-13"),
      position: [70, 428],
      shape: "cicle",
      lineIds: [1, 4, 8],
    },
    {
      stationId: 17,
      stationName: t("Common-teyvat-192be7b183f6eee79-14"),
      position: [-2, 336],
      shape: "cicle",
      lineIds: [4],
    },
    {
      stationId: 18,
      stationName: t("Common-teyvat-192be7b183f6eee79-15"),
      position: [3, 248],
      shape: "cicle",
      lineIds: [4],
    },
    {
      stationId: 19,
      stationName: t("Common-teyvat-192be7b183f6eee79-16"),
      position: [-70, 151],
      shape: "cicle",
      lineIds: [4],
    },
    {
      stationId: 20,
      stationName: t("Common-teyvat-192be7b183f6eee79-17"),
      position: [15, 18],
      shape: "cicle",
      lineIds: [4],
    },
    {
      stationId: 21,
      stationName: t("Common-teyvat-192be7b183f6eee79-18"),
      position: [-87, -77],
      shape: "cicle",
      lineIds: [4],
    },
    {
      stationId: 22,
      stationName: t("Common-teyvat-192be7b183f6eee79-19"),
      position: [83, 628],
      shape: "cicle",
      lineIds: [4],
      tagDirection: 2,
    },
    {
      stationId: 23,
      stationName: t("Common-teyvat-192be7b183f6eee79-20"),
      position: [92, 748],
      shape: "cicle",
      lineIds: [4],
      tagDirection: 2,
    },
    {
      stationId: 24,
      stationName: t("Common-teyvat-192be7b183f6eee79-21"),
      position: [248, 748],
      shape: "cicle",
      lineIds: [4],
    },
    {
      stationId: 25,
      stationName: t("Common-teyvat-192be7b183f6eee79-22"),
      position: [338, 778],
      shape: "cicle",
      lineIds: [4],
    },
    {
      stationId: 26,
      stationName: t("Common-teyvat-192be7b183f6eee79-23"),
      position: [180, 851],
      shape: "cicle",
      lineIds: [4],
    },
    {
      stationId: 27,
      stationName: t("Common-teyvat-192be7b183f6eee79-24"),
      position: [-35, 703],
      shape: "cicle",
      lineIds: [8],
    },
    {
      stationId: 28,
      stationName: t("Common-teyvat-192be7b183f6eee79-25"),
      position: [-230, 813],
      shape: "cicle",
      lineIds: [5, 8],
    },
    {
      stationId: 29,
      stationName: t("Common-teyvat-192be7b183f6eee79-26"),
      position: [-310, 568],
      shape: "cicle",
      lineIds: [5],
    },
    {
      stationId: 30,
      stationName: t("Common-teyvat-192be7b183f6eee79-27"),
      position: [-452, 473],
      shape: "cicle",
      lineIds: [5],
    },
    {
      stationId: 31,
      stationName: t("Common-teyvat-192be7b183f6eee79-28"),
      position: [-240, 971],
      shape: "cicle",
      lineIds: [5],
    },
    {
      stationId: 32,
      stationName: t("Common-teyvat-192be7b183f6eee79-29"),
      position: [-197, 1071],
      shape: "cicle",
      lineIds: [5],
    },
    {
      stationId: 33,
      stationName: t("Common-teyvat-192be7b183f6eee79-30"),
      position: [-280, 1226],
      shape: "cicle",
      lineIds: [5],
    },
    {
      stationId: 34,
      stationName: t("Common-teyvat-192be7b183f6eee79-31"),
      position: [-285, 1451],
      shape: "cicle",
      lineIds: [5, 6],
    },
    {
      stationId: 35,
      stationName: t("Common-teyvat-192be7b183f6eee79-32"),
      position: [-210, 1608],
      shape: "cicle",
      lineIds: [5, 7],
    },
    {
      stationId: 36,
      stationName: t("Common-teyvat-192be7b183f6eee79-33"),
      position: [-605, 1601],
      shape: "cicle",
      lineIds: [7],
    },
    {
      stationId: 37,
      stationName: t("Common-teyvat-192be7b183f6eee79-34"),
      position: [-671, 1511],
      shape: "cicle",
      lineIds: [7, 11],
      tagDirection: 5,
    },
    {
      stationId: 38,
      stationName: t("Common-teyvat-192be7b183f6eee79-35"),
      position: [-362, 1351],
      shape: "cicle",
      lineIds: [6],
    },
    {
      stationId: 39,
      stationName: t("Common-teyvat-192be7b183f6eee79-36"),
      position: [-642, 1326],
      shape: "cicle",
      lineIds: [7],
    },
    {
      stationId: 40,
      stationName: t("Common-teyvat-192be7b183f6eee79-37"),
      position: [-437, 1158],
      shape: "cicle",
      lineIds: [6],
    },
    {
      stationId: 41,
      stationName: t("Common-teyvat-192be7b183f6eee79-38"),
      position: [-552, 1008],
      shape: "cicle",
      lineIds: [6],
    },
    {
      stationId: 42,
      stationName: t("Common-teyvat-192be7b183f6eee79-39"),
      position: [-602, 946],
      shape: "cicle",
      lineIds: [6],
    },
    {
      stationId: 43,
      stationName: t("Common-teyvat-192be7b183f6eee79-40"),
      position: [-525, 829],
      shape: "cicle",
      lineIds: [8],
      tagDirection: 4
    },
    {
      stationId: 44,
      stationName: t("Common-teyvat-192be7b183f6eee79-41"),
      position: [-742, 828],
      shape: "cicle",
      lineIds: [6, 7, 8],
    },
    {
      stationId: 45,
      stationName: t("Common-teyvat-192be7b183f6eee79-42"),
      position: [-805, 728],
      shape: "cicle",
      lineIds: [7],
    },
    {
      stationId: 46,
      stationName: t("Common-teyvat-192be7b183f6eee79-43"),
      position: [-955, 903],
      shape: "cicle",
      lineIds: [7],
    },
    {
      stationId: 47,
      stationName: t("Common-teyvat-192be7b183f6eee79-44"),
      position: [-857, 943],
      shape: "cicle",
      lineIds: [8],
      tagDirection: 2
    },
    {
      stationId: 48,
      stationName: t("Common-teyvat-192be7b183f6eee79-45"),
      position: [-855, 1078],
      shape: "cicle",
      lineIds: [7],
    },
    {
      stationId: 49,
      stationName: t("Common-teyvat-192be7b183f6eee79-46"),
      position: [-725, 1208],
      shape: "cicle",
      lineIds: [7],
    },
    {
      stationId: 50,
      stationName: t("Common-teyvat-192be7b183f6eee79-47"),
      position: [-897, 1411],
      shape: "cicle",
      lineIds: [11, 12],
    },
    {
      stationId: 51,
      stationName: t("Common-teyvat-192be7b183f6eee79-48"),
      position: [-1090, 1388],
      shape: "cicle",
      lineIds: [9, 11],
    },
    {
      stationId: 52,
      stationName: t("Common-teyvat-192be7b183f6eee79-49"),
      position: [-1090, 1076],
      shape: "cicle",
      lineIds: [9, 10],
    },
    {
      stationId: 53,
      stationName: t("Common-teyvat-192be7b183f6eee79-50"),
      position: [-1272, 1173],
      shape: "cicle",
      lineIds: [10],
    },
    {
      stationId: 54,
      stationName: t("Common-teyvat-192be7b183f6eee79-51"),
      position: [-1405, 1271],
      shape: "cicle",
      lineIds: [10],
    },
    {
      stationId: 55,
      stationName: t("Common-teyvat-192be7b183f6eee79-52"),
      position: [-1360, 1388],
      shape: "cicle",
      lineIds: [10, 11],
    },
    {
      stationId: 56,
      stationName: t("Common-teyvat-192be7b183f6eee79-53"),
      position: [-1195, 1576],
      shape: "cicle",
      lineIds: [10, 12],
    },
    {
      stationId: 57,
      stationName: t("Common-teyvat-192be7b183f6eee79-54"),
      position: [-1037, 1491],
      shape: "cicle",
      lineIds: [9, 12],
    },
    {
      stationId: 58,
      stationName: t("Common-teyvat-192be7b183f6eee79-55"),
      position: [-1067, 1791],
      shape: "cicle",
      lineIds: [9],
      tagDirection: 2,
    },
    {
      stationId: 59,
      stationName: t("Common-teyvat-192be7b183f6eee79-56"),
      position: [-1177, 1933],
      shape: "cicle",
      lineIds: [9],
      tagDirection: 3,
    },
    {
      stationId: 60,
      stationName: t("Common-teyvat-192be7b183f6eee79-57"),
      position: [-1310, 1931],
      shape: "cicle",
      lineIds: [9, 10],
      tagDirection: 7,
    },
    {
      stationId: 61,
      stationName: t("Common-teyvat-192be7b183f6eee79-58"),
      position: [-1247, 2116],
      shape: "cicle",
      lineIds: [10],
    },
    {
      stationId: 62,
      stationName: t("Common-teyvat-192be7b183f6eee79-59"),
      position: [-1255, 1701],
      shape: "cicle",
      lineIds: [10],
      tagDirection: 3,
    },
    {
      stationId: 63,
      stationName: t("Common-teyvat-192be7b183f6eee79-60"),
      position: [-1522, 1681],
      shape: "cicle",
      lineIds: [11, 12],
    },
    {
      stationId: 64,
      stationName: t("Common-teyvat-192be7b183f6eee79-61"),
      position: [-1695, 1681],
      shape: "cicle",
      lineIds: [12],
    },
    {
      stationId: 65,
      stationName: t("Common-teyvat-192be7b183f6eee79-62"),
      position: [-1865, 1493],
      shape: "cicle",
      lineIds: [12],
    },
    {
      stationId: 66,
      stationName: t("Common-teyvat-192be7b183f6eee79-63"),
      position: [-2215, 1326],
      shape: "cicle",
      lineIds: [12],
    },
    {
      stationId: 67,
      stationName: t("Common-teyvat-192be7b183f6eee79-64"),
      position: [-1812, 1908],
      shape: "cicle",
      lineIds: [11],
    },
    {
      stationId: 68,
      stationName: t("Common-teyvat-192be7b183f6eee79-65"),
      position: [-1482, 1931],
      shape: "cicle",
      lineIds: [9],
    },
    {
      stationId: 69,
      stationName: t("Common-teyvat-192be7b183f6eee79-66"),
      position: [-1737, 1998],
      shape: "cicle",
      lineIds: [9],
      tagDirection: 3
    },
    {
      stationId: 70,
      stationName: t("Common-teyvat-192be7b183f6eee79-67"),
      position: [-1917, 2093],
      shape: "cicle",
      lineIds: [9, 11],
    },
    {
      stationId: 71,
      stationName: t("Common-teyvat-192be7b183f6eee79-68"),
      position: [-2077, 1883],
      shape: "cicle",
      lineIds: [9],
    },
    {
      stationId: 72,
      stationName: t("Common-teyvat-192be7b183f6eee79-69"),
      position: [-1997, 2211],
      shape: "cicle",
      lineIds: [11],
    },
    {
      stationId: 73,
      stationName: t("Common-teyvat-192be7b183f6eee79-70"),
      position: [-2212, 2316],
      shape: "cicle",
      lineIds: [11],
    },
    {
      stationId: 74,
      stationName: t("Common-teyvat-192be7b183f6eee79-71"),
      position: [-2470, 2316],
      shape: "cicle",
      lineIds: [11],
    },
  ].reduce((map, cur) => {
    map.set(cur.stationId, cur);
    return map;
  }, new Map()),
  lines: [
    {
      lineId: 1,
      lineName: t("Common-teyvat-192be7b183f6eee79-72"),
      color: "#EA0B2A",
      stationIds: [13, 14, 8, 15, 16],
      sign: "1",
      order: 1,
      bendFirst: [true, true, true, true, true],
    },
    {
      lineId: 2,
      lineName: t("Common-teyvat-192be7b183f6eee79-73"),
      color: "#94D40B",
      stationIds: [12, 11, 10, 9, 8, 4],
      sign: "2",
      order: 2,
      bendFirst: [false, true, true, true, true, true],
    },
    {
      lineId: 3,
      lineName: t("Common-teyvat-192be7b183f6eee79-74"),
      color: "#F8D000",
      stationIds: [1, 2, 3, 4, 5, 6, 7],
      sign: "3",
      order: 3,
      bendFirst: [true, true, true, false, true, true, true],
    },
    {
      lineId: 4,
      lineName: t("Common-teyvat-192be7b183f6eee79-75"),
      color: "#60269E",
      stationIds: [21, 20, 19, 18, 17, 16, 22, 23, 26, 25, 24],
      sign: "4",
      order: 4,
      bendFirst: [
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        true,
        true,
      ],
    },
    {
      lineId: 5,
      lineName: t("Common-teyvat-192be7b183f6eee79-76"),
      color: "#934C9A",
      stationIds: [30, 29, 28, 31, 32, 33, 34, 35],
      sign: "5",
      order: 5,
      bendFirst: [true, true, true, true, true, true, true, true],
    },
    {
      lineId: 6,
      lineName: t("Common-teyvat-192be7b183f6eee79-77"),
      color: "#D80169",
      stationIds: [44, 42, 41, 40, 38, 34],
      sign: "6",
      order: 6,
      bendFirst: [false, true, true, true, false, true],
    },
    {
      lineId: 7,
      lineName: t("Common-teyvat-192be7b183f6eee79-78"),
      color: "#FE6B01",
      stationIds: [35, 36, 37, 39, 49, 48, 46, 45, 44],
      sign: "7",
      order: 7,
      bendFirst: [true, true, true, false, true, true, false, true, true],
    },
    {
      lineId: 8,
      lineName: t("Common-teyvat-192be7b183f6eee79-79"),
      color: "#00A0E8",
      stationIds: [47, 44, 43, 28, 27, 16, 4],
      sign: "8",
      order: 8,
      bendFirst: [true, true, false, false, false, false, true],
    },
    {
      lineId: 9,
      lineName: t("Common-teyvat-192be7b183f6eee79-80"),
      color: "#385f88",
      stationIds: [52, 51, 57, 58, 59, 60, 68, 69, 70, 71],
      sign: "2",
      order: 9,
      bendFirst: [true, true, true, false, true, true, true, true, true, true],
    },
    {
      lineId: 10,
      lineName: t("Common-teyvat-192be7b183f6eee79-81"),
      color: "#e8c148",
      stationIds: [52, 53, 54, 55, 56, 62, 60, 61],
      sign: "1",
      order: 10,
      bendFirst: [false, false, false, true, false, true, true, true],
    },
    {
      lineId: 11,
      lineName: t("Common-teyvat-192be7b183f6eee79-82"),
      color: "#dd8d4e",
      stationIds: [37, 50, 51, 55, 63, 67, 70, 72, 73, 74],
      sign: "3",
      order: 11,
      bendFirst: [false, true, true, true, true, true, false, true, true, true],
    },
    {
      lineId: 12,
      lineName: t("Common-teyvat-192be7b183f6eee79-83"),
      color: "#35743c",
      stationIds: [50, 57, 56, 63, 64, 65, 66],
      sign: "4",
      order: 12,
      bendFirst: [true, true, true, true, true, true, true],
    },
  ].reduce((map, cur) => {
    map.set(cur.lineId, cur);
    return map;
  }, new Map()),
  title: t("teyvat"),
  backgroundColor: "#fffee0",
};
